import type { ScheduleType, Ymd } from './queueDates'

/** How the Queue writes dates, times and item types. */

export const TYPE_ICON: Record<ScheduleType, string> = { post: 'file-text', chat: 'message-square', stream: 'video' }

export const LONG_DAY: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' }

/** A 'YYYY-MM-DD' shown as a calendar day (no zone shift: it already is one). */
export function dayLabel(day: Ymd, locale: string, opts: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(locale, { ...opts, timeZone: 'UTC' }).format(new Date(`${day}T00:00:00Z`))
}

export function formatDate(iso: string, timeZone: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { timeZone, month: 'short', day: 'numeric', year: 'numeric' }).format(new Date(iso))
}

export function formatTime(iso: string, timeZone: string, locale: string): string {
  return new Intl.DateTimeFormat(locale, { timeZone, hour: 'numeric', minute: '2-digit' }).format(new Date(iso))
}
